module.exports = __webpack_public_path__ + "static/media/send-backward.32e9fc3c.svg";